import React from 'react'
import {formatCurrency} from '../services/currency'
import {getDate} from '../services/TimeService'
import {Table} from 'react-bootstrap'
import {InvoiceData, OptionsRes} from '../types'

interface Props {
	data: InvoiceData
	options: OptionsRes
}

const InvoiceDataTable: React.FC<Props> = ({data, options}) => {
	return (
		<Table striped bordered hover responsive>
			<tbody>
				<tr>
					<td>1</td>
					<td>Назва файлу</td>
					<td>{data.source_file_name}</td>
				</tr>
				<tr>
					<td>2</td>
					<td>Постачальник</td>
					<td>{data.supplier}</td>
				</tr>
				<tr>
					<td>3</td>
					<td>Покупець</td>
					<td>{data.buyer}</td>
				</tr>
				<tr>
					<td>4</td>
					<td>Номер</td>
					<td>{data.number}</td>
				</tr>
				<tr>
					<td>5</td>
					<td>Дата продажу</td>
					<td>{getDate(data.date_of_sale)}</td>
				</tr>
				<tr>
					<td>6</td>
					<td>Термін оплати</td>
					<td>{getDate(data.due_date)}</td>
				</tr>
				<tr>
					<td>7</td>
					<td>Дата оплати</td>
					<td>{data.paid_on ? getDate(data.paid_on) : 'Не оплачено'}</td>
				</tr>
				<tr>
					<td>8</td>
					<td>Загальна сума</td>
					<td>{(data.total_amount && data.currency) ? formatCurrency(data.total_amount, data.currency) : `${data.total_amount} ${data.currency}`}</td>
				</tr>
				<tr>
					<td>9</td>
					<td>Сума без ПДВ</td>
					<td>{(data.subtotal_amount && data.currency) ? formatCurrency(data.subtotal_amount, data.currency) : `${data.subtotal_amount} ${data.currency}`}</td>
				</tr>
				<tr>
					<td>10</td>
					<td>ПДВ</td>
					<td>{(data.vat && data.currency) ? formatCurrency(data.vat, data.currency) : `${data.vat} ${data.currency}`}</td>
				</tr>
				<tr>
					<td>11</td>
					<td>Валюта</td>
					<td>{data.currency}</td>
				</tr>
				<tr>
					<td>12</td>
					<td>IBAN</td>
					<td style={{
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'break-spaces'
					}}>{data.iban}</td>
				</tr>
				<tr>
					<td>13</td>
					<td>Дата створення</td>
					<td>{getDate(data.created_at)}</td>
				</tr>
				<tr>
					<td>14</td>
					<td>КАСА (з якої здійснено платіж)</td>
					<td>{data.cash_register ? options.cash_registers[data.cash_register]?.full_name : 'Відсутне'}</td>
				</tr>
				<tr>
					<td>15</td>
					<td>Стаття витрат</td>
					<td>{
						data.expense_item
							? options.expense_items[data.expense_item]?.full_name
							: 'Відсутне'
					}</td>
				</tr>
				<tr>
					<td>16</td>
					<td>Область діяльності</td>
					<td>{
						data.activity_area
							? options.activity_areas[data.activity_area]?.full_name
							: 'Відсутне'
					}</td>
				</tr>
				<tr>
					<td>17</td>
					<td>Підрозділ</td>
					<td>{
						data.division
							? options.divisions[data.division]?.full_name
							: 'Відсутне'
					}</td>
				</tr>
				<tr>
					<td>18</td>
					<td>Проєкт</td>
					<td>{
						data.project
							? options.projects[data.project]?.full_name
							: 'Відсутне'
					}</td>
				</tr>
				<tr>
					<td>19</td>
					<td>ПРИМІТКИ - за що цей рахунок</td>
					<td>{data.notes}</td>
				</tr>
			</tbody>
		</Table>
	)
}

export default InvoiceDataTable
